import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { APP_PUBLIC_CONFIG } from './core/app-config.token';
import { type PublicAppConfig } from '#models';
import { environment } from '#environments';

/**
 * Builds MSAL public configuration from the active Angular environment file.
 * The selected environment file is controlled by the Angular build
 * configuration used by the pipeline or local CLI command.
 */
async function bootstrap(): Promise<void> {
    const publicConfig: PublicAppConfig = {
        clientId: environment.msal.auth.clientId,
        authority: environment.msal.auth.authority,
        redirectUri: environment.msal.auth.redirectUri,
        postLogoutRedirectUri: environment.msal.auth.postLogoutRedirectUri,
        apiScopeUri: environment.msal.api.scopeUri,
    };

    await bootstrapApplication(App, {
        providers: [
            { provide: APP_PUBLIC_CONFIG, useValue: publicConfig },
            ...appConfig.providers,
        ],
    });
}

bootstrap().catch(err => console.error('[Bootstrap] Fatal error:', err));
